//Auto-saving user info.
//it is used when the admin user is surfing between tabs, if it  has changed some info
//it should be saved

// taken from https://itnext.io/formik-introduction-autosave-react-19d4c15cfb90

import React, { useEffect, useMemo, useContext, useRef } from 'react';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { UserContext } from './userContext';
import Alert from '../../../components/common/Alert';

const AutoSave = ({ debounceMs = 1000, context }) => {
  const formik = useFormikContext();
  const [state, dispatch] = useContext(UserContext);
  const isMountedRef = useRef(true);

  const activeSection = state.autosaved.find(
    (entry) => Object.keys(entry).toString() === context
  );
  const isSectionSaved = activeSection ? activeSection[context] : false;

  const updateAutosaveStatus = (nextStatus) => {
    const currentStatus = activeSection ? activeSection[context] : false;

    if (currentStatus === nextStatus) {
      return;
    }

    const autosaved = [
      ...state.autosaved.filter(
        (entry) => Object.keys(entry).toString() !== context
      ),
      { [context]: nextStatus },
    ];

    dispatch({
      type: 'UPDATE_AUTOSAVE_STATUS',
      payload: { autosaved },
    });
  };

  const debouncedSyncUser = useMemo(
    () =>
      _.debounce(() => {
        if (!isMountedRef.current) {
          return;
        }

        dispatch({
          type: 'UPDATE_USER',
          payload: { user: formik.values },
        });
      }, debounceMs),
    [dispatch, formik.values, debounceMs]
  );

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      debouncedSyncUser.cancel();
    };
  }, [debouncedSyncUser]);

  useEffect(() => {
    if (formik.isSubmitting) {
      debouncedSyncUser.cancel();
      updateAutosaveStatus(false);
      return undefined;
    }

    if (!formik.dirty || formik.isSubmitting) {
      debouncedSyncUser.cancel();
      return undefined;
    }

    debouncedSyncUser();
    updateAutosaveStatus(true);

    return () => {
      debouncedSyncUser.cancel();
    };
  }, [debouncedSyncUser, formik.dirty, formik.isSubmitting, formik.values]);

  return (
    <p className="text-center text-success">
      {!formik.isSubmitting && isSectionSaved ? (
        <Alert type="warning">
          Recuerda aceptar para guardar los datos modificados
        </Alert>
      ) : null}
    </p>
  );
};

export default AutoSave;
